import { AnalyticsScreenProvider, OnboardingLayout } from "@wayflyer/flyui";
import { useIntl } from "react-intl";
import { useCustomerAppConfig } from "undercarriage";
import { OnboardingStepper } from "onboarding";

import { ContactDetailsForm } from "../../components";
import { COMMON_MESSAGES } from "../../components/common-messages";
import { MESSAGES } from "../../components/contact-details-form/message-definitions";
import { useUserDataMutation } from "../../queries/user-data/queries";
import { useFundingApplicationMutation } from "../../queries/funding-application/queries";

export interface ContactDetailsPageProps {
  onBack?: () => void;
  onContinue: () => void;
}

const FORM_ID = "contact-details-form";

export const ContactDetailsPage = ({ onContinue }: ContactDetailsPageProps) => {
  const intl = useIntl();
  const {
    data: { customerDomain },
  } = useCustomerAppConfig();
  const { isPending: isUserDataSubmitting } = useUserDataMutation(customerDomain);
  const { isPending: isContactDetailsDataSubmitting } = useFundingApplicationMutation(customerDomain);
  const isSubmitting = isUserDataSubmitting || isContactDetailsDataSubmitting;

  return (
    <AnalyticsScreenProvider screen="onboarding-contact-details">
      <OnboardingLayout
        titleSlot={<OnboardingStepper currentStep={1} />}
        title={intl.formatMessage(MESSAGES.contactDetailsHeading)}
        formId={FORM_ID}
        primaryActionType="submit"
        actions={{
          primary: {
            content: intl.formatMessage(COMMON_MESSAGES.nextLabel),
            analyticsId: "funder-contact-details-submit",
            loading: isSubmitting,
            disabled: isSubmitting,
          },
        }}
      >
        <ContactDetailsForm onContinue={onContinue} formId={FORM_ID} />
      </OnboardingLayout>
    </AnalyticsScreenProvider>
  );
};
